/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-07 11:38:33
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

// 设置延迟推广配置
export const setProductPromotion = params => {
	return request({
		url: '/api/team-conf/set-product-promotion',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取延迟推广配置
export const getProductPromotion = params => {
	return request({
		url: '/api/team-conf/get-product-promotion',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 设置商品撞单总规则
export const setProductDuplicate = params => {
	return request({
		url: '/api/team-conf/set-product-duplicate',
		data: params,
		method: AjaxMethod.post,
	});
};

// 设置商品撞单是否允许其他招商跟进
export const setProductDuplicateAlone = params => {
	return request({
		url: '/api/team-conf/set-product-duplicate-alone',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 获取商品规则配置
export const getProductConfig = params => {
	return request({
		url: '/api/team-conf/get-product-config',
		params,
		method: AjaxMethod.get,
	});
};

// 账号列表
export const accountList = data => {
	return request({
		url: '/api/spider-anchor-conf/account-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 获取消息配置
export const getMessageConfList = params => {
	return request({
		url: '/api/message-center/list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 状态开关
export const messageOnOff = data => {
	return request({
		url: '/api/message-center/enable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 账号移除
export const accountRemove = data => {
	return request({
		url: '/api/spider-anchor-conf/account-remove',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 账号新增
export const accountAdd = data => {
	return request({
		url: '/api/spider-anchor-conf/account-add',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 分配规则展示
export const allotRuleInfo = data => {
	return request({
		url: '/api/spider-anchor-conf/allot-rule-info',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 筛选条件列表
export const selectConditionList = data => {
	return request({
		url: '/api/spider-anchor-conf/select-condition-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 筛选条件移除
export const selectConditionRemove = data => {
	return request({
		url: '/api/spider-anchor-conf/select-condition-remove',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 筛选条件启用
export const selectConditionStart = data => {
	return request({
		url: '/api/spider-anchor-conf/select-condition-start',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 筛选条件停用
export const selectConditionStop = data => {
	return request({
		url: '/api/spider-anchor-conf/select-condition-stop',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 过滤条件设置
export const setFilterRule = data => {
	return request({
		url: '/api/spider-anchor-conf/filter-condition-set',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 过滤条件展示
export const getFilterRule = data => {
	return request({
		url: '/api/spider-anchor-conf/filter-condition-info',
		data,
		method: AjaxMethod.post,
	});
};

// 品牌隔离-隔离规则查询 https://yangxuan.w.eolink.com/home/api-studio/inside/GPWIIpSd38e48e928d511cc75e99de3995626f60ba65453/api/2816163/detail/53122486?spaceKey=yangxuan
export const getIsolationRule = data => {
	return request({
		url: '/micro-config-center/isolation-config/query',
		data,
		method: AjaxMethod.post,
	});
};

// 团长和达人冲突数据的总数  https://yangxuan.w.eolink.com/home/api-studio/inside/GPWIIpSd38e48e928d511cc75e99de3995626f60ba65453/api/2826503/detail/53176164?spaceKey=yangxuan
export const getConflictTotal = data => {
	return request({
		url: '/api/institution/get-conflict-total',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 分配规则设置
export const setDistributeRule = data => {
	return request({
		url: '/api/spider-anchor-conf/allot-rule-set',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 自动获取联系方式规则设置
export const autoGetContactSet = data => {
	return request({
		url: '/api/spider-anchor-conf/auto-get-contact-set',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 自动获取联系方式规则展示
export const autoGetContactInfo = data => {
	return request({
		url: '/api/spider-anchor-conf/auto-get-contact-info',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 更新条件设置
export const messageSave = data => {
	return request({
		url: '/api/message-center/update-condition',
		data,
		method: AjaxMethod.post,

		notOrigin: true,
	});
};
// 查询交付审核状态
export const deliveryAuditStatus = params => {
	return request({
		url: 'sample-api/v1/partner/cooperate/delivery-audit',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 交付审核开启
export const deliveryAuditEnable = data => {
	return request({
		url: 'sample-api/v1/partner/cooperate/delivery-audit-enable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 交付审核关闭
export const deliveryAuditDisable = data => {
	return request({
		url: 'sample-api/v1/partner/cooperate/delivery-audit-disable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 查询星选协作状态
export const partnerCooperateStatus = params => {
	return request({
		url: 'sample-api/v1/partner/cooperate/cooperation-partner-detail',
		params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

// 星选协作开启
export const partnerCooperateEnable = data => {
	return request({
		url: 'sample-api/v1/partner/cooperate/cooperation-partner-enable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 星选协作关闭
export const partnerCooperateDisable = data => {
	return request({
		url: 'sample-api/v1/partner/cooperate/cooperation-partner-disable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 星选自动协作-开启
export const autoPartnerCooperateEnable = data => {
	return request({
		url: 'sample-api/v1/partner/cooperate/auto-cooperation-partner-enable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 星选自动协作-关闭
export const autoPartnerCooperateDisable = data => {
	return request({
		url: 'sample-api/v1/partner/cooperate/auto-cooperation-partner-disable',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
// 商品审核设置
export const setAuditConfig = data => {
	return request({
		url: '/api/team-conf/set-product-audit',
		data,
		method: AjaxMethod.post,
	});
};

// 获取商品审核设置
export const getAuditConfig = data => {
	return request({
		url: '/api/team-conf/get-product-audit',
		data,
		method: AjaxMethod.post,
	});
};
